import React, { useState } from "react";

import { Button } from "antd";
import { LoadingOutlined } from "@ant-design/icons";

import { ReactComponent as PDFEditIcon } from "../../../../../../assets/images/common/PDFEditIcon.svg";
import { ReactComponent as PreviewPDFIcon } from "../../../../../../assets/images/common/PreviewPDFIcon.svg";

import "./EditPreviewButton.css";

export default function EditPreviewButton({
  previewTemplate,
  handlePreviewTemplate,
  loadingPreview,
  setLoadingPreview,
}) {
  const [isHovered, setIsHovered] = useState(false);
  const handlePreviewTemplateClick = async () => {
    if (!previewTemplate) {
      setLoadingPreview(true);
    }
    await handlePreviewTemplate();
  };

  const renderIcon = () => {
    if (loadingPreview) {
      return <LoadingOutlined spin className="TemplateBuilder__EditPreviewButton__icon" aria-hidden />;
    }
    if (previewTemplate) {
      return <PDFEditIcon className="TemplateBuilder__EditButton__icon" aria-hidden />;
    }
    return <PreviewPDFIcon className="TemplateBuilder__EditPreviewButton__icon" aria-hidden />;
  };

  return (
    <Button
      htmlType="button"
      className={`TemplateBuilder__EditPreviewButton ${loadingPreview ? "TemplateBuilder__EditPreviewButton--disabled" : ""}`}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={loadingPreview ? null : handlePreviewTemplateClick}
    >
      {isHovered && !loadingPreview && (
        <span>{previewTemplate ? "Edit" : "Preview"}</span>
      )}
      {renderIcon()}
    </Button>
  );
}
